export const translationConnectAi_sv = {
  pageTitle: "Anslut dina AI-verktyg",
  pageDescription:
    "Anslut Claude, Codex och andra AI-verktyg direkt till er chatbot-data via MCP. Ni loggar in med ert vanliga dashboard-konto — AI-verktyget kan göra exakt det ni själva kan göra i dashboarden.",

  serverUrlLabel: "MCP-server URL",
  copy: "Kopiera",
  copied: "Kopierad",
  copyTooltip: "Kopiera till urklipp",

  capabilitiesTitle: "Vad kan ni använda det till?",
  capabilitiesDescription:
    "När ett AI-verktyg är anslutet kan det arbeta direkt med er data — till exempel uppdatera kunskapsbasen, analysera konversationer eller hämta statistik medan ni chattar med det.",
  capabilityWorkspaceTitle: "Arbetsyta",
  capabilityWorkspaceDescription:
    "Se era chatbotar och kunskapsbaser så att AI-verktyget vet vad det arbetar med.",
  capabilityRulesTitle: "Beteenderegler",
  capabilityRulesDescription:
    "Läs, skapa, redigera och ta bort regler — inklusive schemalagda regler (t.ex. kampanjer för en specifik period).",
  capabilityKnowledgeTitle: "Kunskapsbas",
  capabilityKnowledgeDescription:
    "Läs, lägg till och uppdatera kunskapsbasinnehåll. Ändringar används av chatboten omedelbart.",
  capabilityConversationsTitle: "Konversationer",
  capabilityConversationsDescription:
    "Hitta och läs konversationer, markera problem, lägg till kommentarer och exportera konversationer för analys.",
  capabilityTestConversationsTitle: "Testkonversationer",
  capabilityTestConversationsDescription:
    "Ha testkonversationer med er chatbot precis som en besökare i chattwidgeten, med start från dess startmeddelande. Sparas som testkonversationer med en liten timmes- och daggräns.",
  capabilityStatisticsTitle: "Statistik",
  capabilityStatisticsDescription:
    "Hämta rapporter om meddelanden, betyg, ämnen, köp, livechat och svarstider.",

  connectTitle: "Hur ni ansluter",
  connectDescription:
    "Välj det verktyg ni använder. Första gången ombeds ni logga in med ert dashboard-konto och godkänna åtkomsten.",

  clientClaudeTitle: "Claude & Claude Cowork",
  clientClaudeDescription: "claude.ai, Claude Desktop och Cowork — läggs till som en koppling.",
  clientClaudeButton: "Öppna Claude-kopplingar",
  clientClaudeStep1: "Klicka på knappen — den öppnar Inställningar → Kopplingar på claude.ai.",
  clientClaudeStep2:
    "Välj \u201cLägg till anpassad koppling\u201d och klistra in server-URL:en ovan.",
  clientClaudeStep3: "Logga in med ditt dashboard-konto och godkänn åtkomsten.",

  clientClaudeCodeTitle: "Claude Code",
  clientClaudeCodeDescription: "Anthropics kodningsagent i terminalen.",
  clientClaudeCodeStep1:
    "Kör kommandot i din terminal. Det använder en fast callback-port, håll port 8080 fri medan du loggar in:",
  clientClaudeCodeStep2: "Skriv sedan /mcp i Claude Code för att logga in.",

  clientCodexTitle: "Codex",
  clientCodexDescription: "OpenAI:s kodningsagent (CLI och IDE-tillägg).",
  clientCodexStep1: "Kör kommandot i din terminal:",
  clientCodexStep2: "Logga sedan in med:",

  clientCursorTitle: "Cursor",
  clientCursorDescription: "AI-kodredigerare — stöder installation med ett klick.",
  clientCursorButton: "Lägg till i Cursor",
  clientCursorStep1: "Klicka på knappen (kräver att Cursor är installerat) och godkänn servern.",
  clientCursorStep2: "Logga in med ditt dashboard-konto när Cursor frågar.",

  clientVsCodeTitle: "VS Code",
  clientVsCodeDescription: "GitHub Copilot i VS Code — installation med ett klick.",
  clientVsCodeButton: "Lägg till i VS Code",
  clientVsCodeStep1: "Klicka på knappen (kräver att VS Code är installerat) och bekräfta.",
  clientVsCodeStep2: "Starta servern i VS Code och logga in med ditt dashboard-konto.",

  clientOtherTitle: "Andra MCP-klienter",
  clientOtherDescription:
    "Alla verktyg som stöder fjärr-MCP-servrar (Streamable HTTP + OAuth) kan ansluta — t.ex. ChatGPT (utvecklarläge) eller MCP Inspector.",
  clientOtherStep1: "Lägg till en fjärr-MCP-server med URL:en ovan.",
  clientOtherStep2: "Slutför OAuth-inloggningsflödet med ditt dashboard-konto.",

  firstToolHint:
    "Tips: Be AI-verktyget att anropa get_workspace först — det berättar om era chatbotar och kunskapsbaser.",

  securityTitle: "Säkerhet och åtkomst",
  securityBody:
    "Varje användare loggar in med sitt eget dashboard-konto och AI-verktyget får exakt samma behörigheter som användaren har i dashboarden — varken mer eller mindre. Roller med enbart läsrättigheter kan inte göra ändringar via MCP och åtkomsten kan alltid återkallas genom att ta bort användaren från organisationen.",
};
